import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { formatCount } from '@/components/motion/use-reveals'

interface CounterProps {
    value: number
    decimals?: number
    prefix?: string
    suffix?: string
    className?: string
}

/**
 * Renders the final number on the server (so it reads correctly everywhere)
 * and counts up from zero when it scrolls into view.
 */
export const Counter: FC<CounterProps> = ({
    value,
    decimals = 0,
    prefix = '',
    suffix = '',
    className
}): ReactNode => {
    return (
        <span
            className={cn('tabular-nums', className)}
            data-count={value}
            data-decimals={decimals}
            data-prefix={prefix}
            data-suffix={suffix}
        >
            {formatCount(value, decimals, prefix, suffix)}
        </span>
    )
}
